import { Colors, getString } from '@sigma-frontend-libs/commons'

import { icons } from '@/utils'

import render from './render'

export default {
  name: 'noData',

  props: {
    value: [ String, Number, Boolean ],
    label: [ String, Number, Boolean ],

    icon: {
      type: String,
      default: undefined,
      validator: value => {
        return Object.values(icons).includes(value)
      }
    }
  },

  computed: {
    $_value() {
      return getString(this.value)
    },
    $_label() {
      return getString(this.label)
    },

    $_props() {
      let value = this.getTranslate('misc.no.data.value')
      if (this.$_value) {
        value = this.$_value
      }

      const result = {
        value,
        label: this.$_label,
        icon: this.icon,
        iconSVG: this.iconSVG,
        color: Colors.grey,
        disabled: true
      }

      return result
    }
  },

  render
}
